//import './alteration-list.scss'

import { get } from 'lodash'
import Component from "vue-class-component"

import { Alteration } from "@skinsoft/types"
import { ReactiveVue } from "@skinsoft/reactive-vue"
import AlterationLine, { ALTERATION_EDITED, DELETE_ALTERATION } from '../../drawing-editor-components/alteration-line'

@Component({
    components: {
        sAlterationLine: AlterationLine,
    },
    props: ['alterations', 'readOnly'],
    template: require('./alteration-list.html')
})
export default class AlterationList extends ReactiveVue {
    private alterations: Alteration[]
    private readOnly: Boolean

    private DELETE_ALTERATION = DELETE_ALTERATION
    private ALTERATION_EDITED = ALTERATION_EDITED

    private getAlterationKey(index) {
        return get(this.alterations[index], "alterationType.id", new Date().getMilliseconds())
    }
}